// src/i18n/subs.ts —— 06 agent-portal A-03 / A-08 [新增 key] / [改写 key]；06 未给英文者标「本计划定稿」（待回写 06）
// 0045：下级费率字段删除（openRateSet 改写随之移除）；「下级售价」只读弹层文案在 i18n/prices.ts
export const I18N_SUBS = {
  zh: {
    errAcct: '请填写登录账号与初始密码（至少 8 位，含字母与数字）', // [改写 key] 06 A-03（X-24）
    delText: '删除后其推广链接立即失效，其名下用户与下级分销商将归属到我，其 Bot 改挂到我，操作不可恢复。', // [改写 key] 06 A-03（X-10）
    myPwdTip: '修改后所有设备（含当前）需重新登录。', // [改写 key] 06 A-08（S-97）
    errOldPwdEmpty: '请输入当前密码', // [新增 key] 06 A-08
  },
  en: {
    errAcct: 'Enter a login account and an initial password (8+ characters with letters and digits)',
    delText: 'Their referral link stops working immediately; their users and sub-agents move to you, and so do their bots. This cannot be undone.',
    myPwdTip: 'All devices, including this one, will need to sign in again.', // 本计划定稿
    errOldPwdEmpty: 'Enter your current password', // 本计划定稿
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值
export const REWRITES_SUBS: readonly string[] = ['errAcct', 'delText', 'myPwdTip'];
